module.exports = __webpack_public_path__ + "img/video_title.848b71d0.png";